<template>
    <main class="legal_notice_container">
        <h1>{{ $t('legal.title') }}</h1>
        <div class="legalContainer">
            <p class="legalTitles">{{ $t('legal.titleParagraph1') }}</p>
            <p>{{ $t('legal.paragraph1') }}</p>
            <p class="legalSubtitles">{{ $t('legal.ownerTitle') }}</p>
            <p class="legalNoMargin">GMA Logistics</p>
            <p class="legalNoMargin">501 avenue de la couronne des prés, 78680 Epône</p>
            <p class="legalNoMargin">06 58 56 80 83</p>
            <p class="legalNoMargin">contact@gma-logistics.com</p>
            <p class="legalSubtitles">{{ $t('legal.release') }}</p>
            <p class="legalNoMargin">Alan Lasry – contact@gma-logistics.com</p>
            <p class="legalNoMargin">{{ $t('legal.releaseText') }}</p>
            <p class="legalSubtitles">{{ $t('legal.host') }}</p>
            <p class="legalNoMargin">Render Service Inc</p>
            <p class="legalNoMargin">525 Brannan St Ste 300, San Francisco, CA 94107, United States</p>
            <p class="legalNoMargin">415-830-4762</p>

            <p class="legalTitles">{{ $t('legal.titleParagraph2') }}</p>
            <p>{{ $t('legal.paragraph2') }}</p>
            <ul>
                <li>{{ $t('legal.activityPoint1') }}</li>
                <li>{{ $t('legal.activityPoint2') }}</li>
                <li>{{ $t('legal.activityPoint3') }}</li>
            </ul>

            <p class="legalTitles">{{ $t('legal.titleParagraph3') }}</p>
            <p>{{ $t('legal.paragraph3') }}</p>

            <p class="legalTitles">{{ $t('legal.titleParagraph4') }}</p>
            <p>{{ $t('legal.paragraph4') }}</p>
            <p>{{ $t('legal.paragraph4B') }}</p>

            <p class="legalTitles">{{ $t('legal.titleParagraph5') }}</p>
            <p>{{ $t('legal.paragraph5') }}</p>
            <p>{{ $t('legal.paragraph5B') }}: contact@gma-logistics.com.</p>

            <p class="legalTitles">{{ $t('legal.titleParagraph6') }}</p>
            <p>{{ $t('legal.paragraph6') }}</p>

        </div>
    </main>
</template>

<style scoped>
.legal_notice_container {
    padding-top: 120px;
}
.legalContainer {
    margin: 10px 30px;
    text-align: start;
}
.legalTitles {
    font-weight: 800;
    padding-top: 15px;
}
.legalSubtitles {
    font-weight: 600;
    padding-top: 8px;
}
.legalNoMargin {
    line-height: 2px;
}

@media screen and (max-width: 750px ) {
    .legalNoMargin{
        line-height: normal;
    }
}
</style>